/**
 * 我的活动
 * @returns
 */
import { Box, Button, Flex, SimpleGrid, Image } from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";
import ActivityItem from "@/components/activity";
import { Activity } from "@/types/activity";
import ArrowRight from "@/assets/images/arrow_right.png";
import actImg from "@/assets/images/activity_img1.png";
import emptyImg from "@/assets/images/empty.png";

const MyActivities = () => {
  const navigate = useNavigate();

  const activitiesList = [
    // {
    //   template1: `${actImg}`,
    //   name: "AI光影建筑故事绘",
    //   start_time: 1714510561,
    //   end_time: 1716961605,
    //   status: "进行中",
    // },
    // {
    //   template1: `${actImg}`,
    //   name: "AI光影建筑故事绘",
    //   start_time: 1714510561,
    //   end_time: 1716961605,
    //   status: "进行中",
    // },
    // {
    //   template1: `${actImg}`,
    //   name: "AI光影建筑故事绘",
    //   start_time: 1714510561,
    //   end_time: 1716961605,
    //   status: "已结束",
    // },
  ] as Activity[];
  return (
    <Box h="calc(100vh - 61px)" overflow={"hidden"}>
      <Box sx={{ height: "100%" }} width="80%" m="0 auto">
        <Flex h="100%" flexDirection={"column"}>
          <Flex
            justifyContent={"space-between"}
            alignItems="center"
            mt="40px"
            mb="20px"
          >
            <Box color="#27314D" fontWeight="bold" fontSize="24px">
              我的活动
            </Box>
            <Button
              color="#27314D"
              fontSize={"12px"}
              fontWeight="normal"
              variant="link"
              onClick={() => {
                navigate("/activitycenter");
              }}
            >
              活动中心 <Image src={ArrowRight} />
            </Button>
          </Flex>
          <Box h="0" flex={1}>
          {!activitiesList.length && (
            <Flex
              h="100%"
              flexDir={"column"}
              justifyContent="center"
              alignItems={"center"}
            >
              <Image src={emptyImg} />
              <Box fontSize={"16px"} color={"#8E94A9"}>
                您还未参加任何活动，快去活动中心挑选适合你的活动吧～
              </Box>
            </Flex>
          )}
          {activitiesList && activitiesList.length>0 && (
            <Box h="100%" pr="10px" overflow={"auto"}>
              <SimpleGrid spacingX="28px" spacingY="40px" mb="40px" columns={2}>
              {activitiesList.map((item, index) => {
                return (
                  <Box key={index}>
                    <ActivityItem activity={item} />
                  </Box>
                );
              })}
            </SimpleGrid>
            </Box>
            
          )}
          </Box>
          
          
        </Flex>
      </Box>
    </Box>
  );
};
export default MyActivities;
